import gql from 'graphql-tag'

export const GET_VEHICLE_GROUPS = gql`
  query VgroupsPaginated($filter: GetVgroupsFilterWithPagination) {
    vgroupsPaginated(filter: $filter) {
      errorCode
      errorName
      isSuccessful
      message
      status
      vgroups {
        data {
          id
          name
        }
        pagination {
          page
          show
          actualTotal
          total
        }
      }
    }
  }
`

export const GET_VEHICLE_TYPES = gql`
  query VehicleTypes($filter: GetVehicleTypesFilter) {
    vehicleTypes(filter: $filter) {
      isSuccessful
      message
      vehicleTypes {
        data {
          vehicleTypeId
          isActive
          type
          __typename
        }
        pagination {
          total
          page
          show
          __typename
        }
        __typename
      }
      status
      __typename
    }
  }
`
